import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Icon from "@/components/icon/Icon";
import { NoPoint, Sizes } from "@/components/icon/IconList";
import { useAuthStore } from "@/lib/auth/AuthStore";
import { Button, Divider, Tag, Typography } from "@bookips/sds";
import Image from "next/image";
import { Fragment, useState } from "react";
import CouponSelectDialog from "../CouponSelectDialog";
import { DropDownBox } from "../DropDownBox";
import usePodCouponHandler from "../hooks/useCouponHandler";
import { usePodCouponQuery } from "../queries/useCouponQuery";
// pod 주문 상품
const PodOrderSection = (param)=>{
    let { podOrderData , orderType  } = param;
    const { isLoggedIn  } = useAuthStore();
    const { data: podCoupons  } = usePodCouponQuery({
        enabled: isLoggedIn && orderType === "pod"
    });
    const { applyCouponCheck , checkAvailableCouponList , hasCoupon , getAppliedCoupon: appliedCoupon , hasAnyCoupon , selectedProductId , setSelectedProductId  } = usePodCouponHandler({
        orderItems: podOrderData.items,
        podCoupons: podCoupons === null || podCoupons === void 0 ? void 0 : podCoupons.coupons
    });
    const [open, setOpen] = useState(false);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(DropDownBox, {
                headTitle: /*#__PURE__*/ _jsxs(Typography, {
                    variant: "h6",
                    className: "flex items-center gap-2",
                    children: [
                        "주문상품",
                        /*#__PURE__*/ _jsxs("span", {
                            className: "text-secondary-main text-xl",
                            children: [
                                podOrderData.items.length,
                                "개"
                            ]
                        })
                    ]
                }),
                bodyElement: /*#__PURE__*/ _jsx("div", {
                    className: "mt-6 flex flex-col gap-5",
                    children: podOrderData.items.map((item, index)=>{
                        var _item_pod, _item_pod1, _item_pod2, _appliedCoupon;
                        /*#__PURE__*/ return _jsxs(Fragment, {
                            children: [
                                /*#__PURE__*/ _jsx(OrderItem, {
                                    id: item.id,
                                    title: (_item_pod = item.pod) === null || _item_pod === void 0 ? void 0 : _item_pod.options.orderTitle,
                                    price: (_item_pod1 = item.pod) === null || _item_pod1 === void 0 ? void 0 : _item_pod1.options.price,
                                    subTitle: (_item_pod2 = item.pod) === null || _item_pod2 === void 0 ? void 0 : _item_pod2.originalFileName,
                                    appliedCoupon: hasCoupon(item.id),
                                    couponDiscount: (_appliedCoupon = appliedCoupon(item.id)) === null || _appliedCoupon === void 0 ? void 0 : _appliedCoupon.discountAmount,
                                    isPointUnusable: item.isPointUnusable,
                                    onChangeCoupon: ()=>{
                                        // 쿠폰 변경 핸들러
                                        setSelectedProductId(item.id);
                                        setOpen(true);
                                    },
                                    checkAvailableCouponList: checkAvailableCouponList
                                }),
                                index !== podOrderData.items.length - 1 && /*#__PURE__*/ _jsx(Divider, {})
                            ]
                        }, item.id);
                    })
                }),
                openDropDown: false,
                dropDownMode: false,
                headRightElement: hasAnyCoupon() && /*#__PURE__*/ _jsx(Tag, {
                    size: "md",
                    color: "red",
                    rating: false,
                    children: /*#__PURE__*/ _jsx(Typography, {
                        variant: "subtitle2",
                        children: "쿠폰 적용중"
                    })
                })
            }),
            /*#__PURE__*/ _jsx(CouponSelectDialog, {
                isOpen: open,
                onClose: ()=>setOpen(false),
                availableCoupons: podCoupons === null || podCoupons === void 0 ? void 0 : podCoupons.coupons,
                selectedProductId: selectedProductId !== null && selectedProductId !== void 0 ? selectedProductId : "",
                appliedCoupon: (id)=>appliedCoupon(id),
                onCouponSelect: (coupon)=>applyCouponCheck(selectedProductId, coupon)
            })
        ]
    });
};
const OrderItem = (param)=>{
    let { id , title , price , subTitle , appliedCoupon , couponDiscount , isPointUnusable , onChangeCoupon , checkAvailableCouponList  } = param;
    var _checkAvailableCouponList;
    const handleChangeCoupon = (id)=>{
        onChangeCoupon();
    };
    return /*#__PURE__*/ _jsx("div", {
        role: "listitem",
        className: "flex gap-5 justify-between  rounded-md",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "flex gap-4",
            children: [
                /*#__PURE__*/ _jsx("p", {
                    className: "relative w-[68px] h-[68px] overflow-hidden rounded-md shrink-0",
                    children: /*#__PURE__*/ _jsx(Image, {
                        src: "/static/assets/pod-covers/material-book-cover.jpg",
                        fill: true,
                        alt: "pod-cover"
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "flex flex-col gap-3",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "flex flex-col gap-1 w-full min-w-0",
                            children: [
                                /*#__PURE__*/ _jsx(Typography, {
                                    variant: "body1",
                                    className: "break-all overflow-wrap-anywhere",
                                    children: title
                                }),
                                /*#__PURE__*/ _jsx(Typography, {
                                    variant: "body2",
                                    className: "text-gray-500 break-all whitespace-break-spaces",
                                    children: subTitle
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "flex gap-2 flex-col",
                            children: [
                                appliedCoupon && /*#__PURE__*/ _jsxs(Typography, {
                                    variant: "subtitle1",
                                    className: "flex gap-1.5 items-center",
                                    children: [
                                        (price - couponDiscount).toLocaleString(),
                                        "원",
                                        /*#__PURE__*/ _jsxs(Typography, {
                                            variant: "caption",
                                            className: "text-muted text line-through",
                                            children: [
                                                price === null || price === void 0 ? void 0 : price.toLocaleString(),
                                                " 원"
                                            ]
                                        })
                                    ]
                                }),
                                !appliedCoupon && /*#__PURE__*/ _jsxs(Typography, {
                                    variant: "subtitle1",
                                    className: "text-strong",
                                    children: [
                                        price === null || price === void 0 ? void 0 : price.toLocaleString(),
                                        "원"
                                    ]
                                }),
                                isPointUnusable && /*#__PURE__*/ _jsxs(Typography, {
                                    variant: "caption",
                                    className: "text-secondary flex items-center gap-1",
                                    children: [
                                        /*#__PURE__*/ _jsx(Icon, {
                                            icon: NoPoint,
                                            size: Sizes.small,
                                            className: "text-muted w-4 h-4"
                                        }),
                                        "포인트 사용 불가 상품"
                                    ]
                                }),
                                appliedCoupon && /*#__PURE__*/ _jsxs("div", {
                                    className: "flex gap-2 items-center",
                                    children: [
                                        /*#__PURE__*/ _jsx(Button, {
                                            variant: "stroke",
                                            color: "secondary",
                                            size: "sm",
                                            onClick: ()=>handleChangeCoupon(id),
                                            children: "쿠폰변경"
                                        }),
                                        /*#__PURE__*/ _jsxs(Typography, {
                                            variant: "caption",
                                            className: "text-red-400",
                                            children: [
                                                couponDiscount === null || couponDiscount === void 0 ? void 0 : couponDiscount.toLocaleString(),
                                                "원 할인"
                                            ]
                                        })
                                    ]
                                }),
                                !appliedCoupon && ((_checkAvailableCouponList = checkAvailableCouponList()) === null || _checkAvailableCouponList === void 0 ? void 0 : _checkAvailableCouponList.length) > 0 && /*#__PURE__*/ _jsxs("div", {
                                    className: "flex gap-2 items-center",
                                    children: [
                                        /*#__PURE__*/ _jsx(Button, {
                                            variant: "fill",
                                            size: "sm",
                                            className: "bg-red-400",
                                            onClick: ()=>handleChangeCoupon(id),
                                            children: "쿠폰사용"
                                        }),
                                        /*#__PURE__*/ _jsx(Typography, {
                                            variant: "caption",
                                            className: "text-red-400",
                                            children: "사용가능한 쿠폰이 있어요."
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
export default PodOrderSection;
